import { render } from "./AchievementNotification2.vue?vue&type=template&id=c95b6f56"
import script from "./AchievementNotification2.vue?vue&type=script&lang=js"
export * from "./AchievementNotification2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/achievementNotifications/AchievementNotification2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c95b6f56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c95b6f56', __exports__)) {
    api.reload('c95b6f56', __exports__)
  }
  
  module.hot.accept("./AchievementNotification2.vue?vue&type=template&id=c95b6f56", () => {
    api.rerender('c95b6f56', render)
  })

}


export default __exports__